import { z } from 'zod';
import { PAPEIS, type Papel } from './permissoes.js';

/** GET /versao (publico): versao SemVer da API em execucao (vem do package.json raiz, injetada no build). */
export interface VersaoResponse {
  versao: string;
}

export interface NovidadeItem {
  titulo: string;
  texto: string;
  /** Nome da tela e link (rota do app). */
  tela: string | null;
  link: string | null;
  /** Papeis a quem interessa; vazio = todos. */
  papeis: Papel[];
  /** Secao do arquivo ("# Novidades", "# Melhorias", "# Correções"); null em arquivo sem secoes. */
  grupo: NovidadeGrupo | null;
  /** Slug da pagina da Ajuda (ex.: telas/precificar-formacao). */
  ajuda: string | null;
}

export type NovidadeGrupo = 'novidade' | 'melhoria' | 'correcao';

export interface NovidadesVersao {
  versao: string;
  data: string | null;
  itens: NovidadeItem[];
}

/** GET /novidades: versoes com novidades que o usuario ainda nao viu (mais nova primeiro; so itens dos papeis dele). `?todas=true`: a mais recente, vista ou nao. */
export interface NovidadesResponse {
  versaoAtual: string;
  novidades: NovidadesVersao[];
}

export const novidadesQuerySchema = z.object({ todas: z.enum(['true', 'false']).transform((v) => v === 'true').optional() });
export const novidadeVistaSchema = z.object({ versao: z.string().regex(/^\d+\.\d+\.\d+$/) });
export type NovidadeVistaDto = z.infer<typeof novidadeVistaSchema>;
export const PAPEIS_NOVIDADE: readonly Papel[] = PAPEIS;
